import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["adjuntosServicioBox"];

  connect() {
    // Si el contenedor de adjuntos está vacío, agregar uno inicial
    const boxes = document.querySelectorAll('.adjuntos-servicio-box');
    boxes.forEach(box => {
      if (box.childElementCount === 0) {
        this.addInitialAdjunto(box);
      }
    });
  }

  addInitialAdjunto(box) {
    const serviceIndex = box.getAttribute('data-service-index');
    let index = 1;
    const fileFormats = JSON.stringify(['png', 'jpg', 'jpeg', 'pdf']).replace(/"/g, '&quot;');

    box.insertAdjacentHTML(
      "beforeend",
      `
        <div class="row mt-3 border-top pt-4 adjunto adjunto-servicio-item" id="adjunto_${index}">
          <div class="insertar-botoncerrar d-flex justify-content-end">
            <i style="font-size: 1.5rem; color: #004A97; cursor: pointer;"
               class="boton-cerrar fa-regular fa-circle-xmark"
               data-action="click->documentos-adjuntos#removeDocumentoInternacion"
               data-index="${index}"
               data-service-index="${serviceIndex}"></i>
          </div>
          <div class="row">
            <div class="col-6 input-container-form">
              <div class="label-paciente-datos">Tipo de documento</div>
              <select label="false" class="icon-select form-control input-paciente-datos"
                      name="internacion[servicios][servicio_${serviceIndex}][adjuntos_servicios][][tipo]"
                      id="internacion_servicios_servicio_${serviceIndex}_adjuntos_adjunto_${index}_tipo_documento">
                <option value="">Selecciona tipo de documento</option>
                <option value="documento" selected>Documentos del Servicio</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-6 input-container-form">
              <div class="label-paciente-datos">Fecha</div>
              <div class="mb-3 string optional internacion_adjuntos_adjunto_${index}_fecha">
                <input class="form-control string optional input-paciente-datos" type="date"
                       onkeydown="return false;" max="${new Date().toISOString().split('T')[0]}"
                       name="internacion[servicios][servicio_${serviceIndex}][adjuntos_servicios][][fecha]"
                       id="internacion_servicios_servicio_${serviceIndex}_adjuntos_adjunto_${index}_fecha">
              </div>
            </div>
            <div class="col-6 input-container-form">
              <div class="label-paciente-datos">Descripción</div>
              <input label="false" placeholder="Indica descripción"
                     class="form-control input-paciente-datos" maxlength="100" size="100" type="text"
                     name="internacion[servicios][servicio_${serviceIndex}][adjuntos_servicios][][descripcion]"
                     id="internacion_servicios_servicio_${serviceIndex}_adjuntos_adjunto_${index}_descripcion">
            </div>
          </div>
          <div class="row" data-controller="file-format" data-file-format-array-value="${fileFormats}">
            <div class="col-6 input-container-form">
              <div class="input-file">
                <label  class="mb-0 label-paciente-datos"
                        for="internacion_servicios_servicio_${serviceIndex}_adjuntos_adjunto_${index}_file"
                        onclick="event.stopPropagation(); event.preventDefault();">
                  Archivo adjunto
                </label>
                <div data-file-format-target="inputFile">
                  <div  data-action="click->file-format#openFileDialog"
                        class="mb-3 file optional internacion_adjuntos_servicios_file">
                    <input  class="form-control file optional obligatorio-recurso"
                            id="internacion_servicios_servicio_${serviceIndex}_adjuntos_adjunto_${index}_file"
                            accept="image/png, image/jpeg, image/jpg, application/pdf"
                            type="file"
                            name="internacion[servicios][servicio_${serviceIndex}][adjuntos_servicios][][url_archivo]"
                            data-default-field="url_archivo"
                            data-action="change->file-format#displayFileName change->input-empty-validator#clearError">
                  </div>
                </div>
              </div>
              <span id="error_message" class="error-message not_remove text-danger"></span>
            </div>
          </div>
        </div>
      `
    );
  }

  addDocumentoInternacion(event) {
    const nuevosAdjuntos = document.getElementById("nuevos-adjuntos");
    let index = nuevosAdjuntos.childElementCount + 1;
    const fileFormats = JSON.stringify(['png', 'jpg', 'jpeg', 'pdf']).replace(/"/g, '&quot;');

    nuevosAdjuntos.insertAdjacentHTML(
      "beforeend",
      `
        <div class="row mt-3 border-top pt-2 adjunto" id="adjunto_${index}" data-modulo-validator-target="group">
          <div class="insertar-botoncerrar d-flex justify-content-end">
            <i  style="font-size: 1.5rem; color: black; border-radius: 50px; cursor: pointer; color:  #004A97;"
                class="boton-cerrar fa-regular fa-circle-xmark"
                data-action="click->documentos-adjuntos#removeDocumentoInternacion"
                data-index="${index}"></i>
          </div>
          <div class="row">
            <div class="col-6 input-container-form">
              <div class="label-paciente-datos">Tipo de documento</div>
              <select label="false" class="icon-select form-control input-paciente-datos obligatorio-recurso"
                      name="internacion[adjuntos][adjunto_${index}][tipo_documento]"
                      id="internacion_adjuntos_adjunto_${index}_tipo_documento"
                      data-action="change->input-empty-validator#clearError">
                <option value="">Selecciona tipo de documento</option>
                <option value="Documento del paciente">Documento del paciente</option>
                <option value="Documento de la internación">Documento de la internación</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-6 input-container-form">
              <div class="label-paciente-datos">Fecha</div>
              <div class="mb-0 string optional internacion_adjuntos_adjunto_${index}_fecha">
                <input  class="form-control string optional input-paciente-datos obligatorio-recurso"
                        type="date"
                        onkeydown="return false;" max="${new Date().toISOString().split('T')[0]}"
                        name="internacion[adjuntos][adjunto_${index}][fecha]"
                        id="internacion_adjuntos_adjunto_${index}_fecha"
                        data-action="change->input-empty-validator#clearError">
              </div>
            </div>
            <div class="col-6 input-container-form">
              <div class="label-paciente-datos">Descripción</div>
              <input  label="false" placeholder="Indica descripción"
                      class="form-control input-paciente-datos obligatorio-recurso"
                      maxlength="100" size="100" type="text"
                      name="internacion[adjuntos][adjunto_${index}][descripcion_adjuntos]"
                      id="internacion_adjuntos_adjunto_${index}_descripcion_adjuntos"
                      data-action="change->input-empty-validator#clearError">
            </div>
          </div>
          <div class="row" data-controller="file-format" data-file-format-array-value="${fileFormats}">
            <div class="col-6 input-container-form">
              <div class="input-file">
                <label  class="mb-0 label-paciente-datos"
                        for="internacion_adjuntos_adjunto_${index}_file"
                        onclick="event.stopPropagation(); event.preventDefault();">
                  Archivo adjunto
                </label>
                <div data-file-format-target="inputFile">
                  <div class="mb-3 file optional internacion_adjuntos_adjunto_${index}_file"
                        data-action="click->file-format#openFileDialog">
                    <input  class="form-control file optional obligatorio-recurso"
                            id="internacion_adjuntos_adjunto_${index}_file"
                            accept="image/png, image/jpeg, image/jpg, application/pdf"
                            data-action="change->file-format#displayFileName change->input-empty-validator#clearError"
                            type="file"
                            name="internacion[adjuntos][adjunto_${index}][file]">
                  </div>
                </div>
              </div>
              <span id="error_message" class="error-message not_remove text-danger"></span>
            </div>
          </div>
        </div>
      `
    );
  }

  removeDocumentoInternacion(event) {
    const index = event.target.dataset.index;
    const serviceIndex = event.target.dataset.serviceIndex;
    const adjunto = document.getElementById(`adjunto_${index}`);
    adjunto.remove();

    // Actualizar los index de los elementos adjuntos
    const adjuntos = document.querySelectorAll('.adjunto');
    adjuntos.forEach((adjunto, i) => {

      const inputsName = adjunto.querySelectorAll('input, select');
      const inputsId = adjunto.querySelectorAll('input, select');
      const labels = adjunto.querySelectorAll('label');
      const containers = adjunto.querySelectorAll('[class*="adjunto_"]');

      const adjuntoIndex = i + 1;

      if (serviceIndex?.toString().trim() !== '') {
        inputsName.forEach(inputName => inputName.name = inputName.name
          .replace(/servicio_\d+/, `servicio_${serviceIndex}`)
          .replace(/adjunto_\d+/, `adjunto_${adjuntoIndex}`));

        inputsId.forEach(inputId => inputId.id = inputId.id
          .replace(/servicio_\d+/, `servicio_${serviceIndex}`)
          .replace(/adjunto_\d+/, `adjunto_${adjuntoIndex}`));

        labels.forEach(label => label.htmlFor = label.htmlFor
          .replace(/servicio_\d+/, `servicio_${serviceIndex}`)
          .replace(/adjunto_\d+/, `adjunto_${adjuntoIndex}`));

        containers.forEach(container => {container.className = container.className
          .replace(/servicio_\d+/g, `servicio_${serviceIndex}`)
          .replace(/adjunto_\d+/g, `adjunto_${adjuntoIndex}`)});

        adjunto.querySelector('i').dataset.serviceIndex = serviceIndex;
      } else {
        inputsName.forEach(inputName => {
          inputName.name = inputName.name.replace(/adjunto_\d+/, `adjunto_${adjuntoIndex}`)
        });
        inputsId.forEach(inputId => {
          inputId.id = inputId.id.replace(/adjunto_\d+/, `adjunto_${adjuntoIndex}`)
        });
        labels.forEach(label => {
          label.htmlFor = label.htmlFor.replace(/adjunto_\d+/, `adjunto_${adjuntoIndex}`)
        });
        containers.forEach(container => {
          container.className = container.className.replace(/adjunto_\d+/g, `adjunto_${adjuntoIndex}`)
        });
      }
      adjunto.querySelector('i').dataset.index = adjuntoIndex;
      adjunto.id = adjunto.id.replace(/\d+/, adjuntoIndex);
    });
  }

  addServicioDocumento(event) {
    // Encuentra el contenedor más cercano de adjuntos
    const adjuntosServicioBox = event.currentTarget.closest('#adjuntos-servicio')?.querySelector('.adjuntos-servicio-box');
    
    if (!adjuntosServicioBox) {
      console.error('No se encontró el contenedor de adjuntos');
      return;
    }

    const serviceIndex = adjuntosServicioBox.getAttribute('data-service-index');

    // Calcula el índice basándose en los elementos existentes con la clase "adjunto"
    let index = adjuntosServicioBox.querySelectorAll(".adjunto").length + 1;

    const fileFormats = JSON.stringify(['png', 'jpg', 'jpeg', 'pdf']).replace(/"/g, '&quot;');

    adjuntosServicioBox.insertAdjacentHTML(
      "beforeend",
      `
        <div class="row mt-3 border-top pt-4 adjunto adjunto-servicio-item" id="adjunto_${index}">
          <div class="insertar-botoncerrar d-flex justify-content-end">
            <i style="font-size: 1.5rem; color: #004A97; cursor: pointer;"
               class="boton-cerrar fa-regular fa-circle-xmark"
               data-action="click->documentos-adjuntos#removeDocumentoInternacion"
               data-index="${index}"
               data-service-index="${serviceIndex}"></i>
          </div>
          <div class="row">
            <div class="col-6 input-container-form">
              <div class="label-paciente-datos">Tipo de documento</div>
              <select label="false" class="icon-select form-control input-paciente-datos"
                      name="internacion[servicios][servicio_${serviceIndex}][adjuntos_servicios][][tipo]"
                      id="internacion_servicios_servicio_${serviceIndex}_adjuntos_adjunto_${index}_tipo_documento">
                <option value="">Selecciona tipo de documento</option>
                <option value="documento" selected>Documentos del Servicio</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-6 input-container-form">
              <div class="label-paciente-datos">Fecha</div>
              <div class="mb-3 string optional internacion_adjuntos_adjunto_${index}_fecha">
                <input class="form-control string optional input-paciente-datos" type="date"
                       onkeydown="return false;" max="${new Date().toISOString().split('T')[0]}"
                       name="internacion[servicios][servicio_${serviceIndex}][adjuntos_servicios][][fecha]"
                       id="internacion_servicios_servicio_${serviceIndex}_adjuntos_adjunto_${index}_fecha">
              </div>
            </div>
            <div class="col-6 input-container-form">
              <div class="label-paciente-datos">Descripción</div>
              <input label="false" placeholder="Indica descripción"
                     class="form-control input-paciente-datos" maxlength="100" size="100" type="text"
                     name="internacion[servicios][servicio_${serviceIndex}][adjuntos_servicios][][descripcion]"
                     id="internacion_servicios_servicio_${serviceIndex}_adjuntos_adjunto_${index}_descripcion">
            </div>
          </div>
          <div class="row" data-controller="file-format" data-file-format-array-value="${fileFormats}">
            <div class="col-6 input-container-form">
              <div class="input-file">
                <label  class="mb-0 label-paciente-datos"
                        for="internacion_servicios_servicio_${serviceIndex}_adjuntos_adjunto_${index}_file"
                        onclick="event.stopPropagation(); event.preventDefault();">
                  Archivo adjunto
                </label>
                <div data-file-format-target="inputFile">
                  <div  data-action="click->file-format#openFileDialog"
                        class="mb-3 file optional internacion_adjuntos_servicios_file">
                    <input  class="form-control file optional obligatorio-recurso"
                            id="internacion_servicios_servicio_${serviceIndex}_adjuntos_adjunto_${index}_file"
                            accept="image/png, image/jpeg, image/jpg, application/pdf"
                            type="file"
                            name="internacion[servicios][servicio_${serviceIndex}][adjuntos_servicios][][url_archivo]"
                            data-default-field="url_archivo"
                            data-action="change->file-format#displayFileName change->input-empty-validator#clearError">
                  </div>
                </div>
              </div>
              <span id="error_message" class="error-message not_remove text-danger"></span>
            </div>
          </div>
        </div>
      `
    );
  }
}
